<ng-container *ngIf="loading">
  <div class="text-center py-5">
    <p>Cargando...</p>
  </div>
</ng-container>
<div [style.display]="loading ? 'none' : 'block'">
  <ng-container *ngIf="paymentCards.length !== 0 && !showCustomForm">
    <h1 class="fw-bold fs-2 text-center mb-4">Selecciona la tarjeta</h1>
    <p>
      Debes seleccionar la tarjeta que va a ser usada para generar cobros automáticos en las fechas de corte de tu
      crédito
    </p>
    <ng-container>
      <app-payment-card-list
        [cardSelected]="cardSelected"
        [paymentCards]="paymentCards"
        (selected)="onSelectCard($event)"
      />
      <p class="no-card-info" *ngIf="cardSelected === undefined">
        Alerta: tu puntaje crediticio en nuestra plataforma se verá afectado si no provees una tarjeta débito para
        realizar cobro automático
      </p>
      <div class="mt-2">
        <app-button (clicked)="confirm()"> Continuar </app-button>
        <a href="#" class="add-card" (click)="$event.preventDefault(); openCustomForm()"> Añadir tarjeta </a>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="showCustomForm || (paymentCards.length === 0 && !loading)">
    <ng-container *ngIf="!showCustomForm">
      <h1 class="fw-bold fs-2 text-center mb-4">Añadir tarjeta</h1>
      <div class="card mb-4">
        <div class="card-body">
          <p class="px-2">
            <b>
              Es necesario ingresar una tarjeta de débito para efectuar el cobro automático de la cuota en la fecha de
              vencimiento.
            </b>
          </p>
          <p>
            Tranqui, no te vamos a cobrar nada ahora. Solo usamos los datos de tu tarjeta para poder cobrarte las cuotas
            después, cuando llegue el momento. Tus datos están seguros, no los guardamos ni los compartimos.
          </p>
        </div>
      </div>
      <app-button (clicked)="openCustomForm()"> Añadir tarjeta </app-button>
    </ng-container>

    <ng-container *ngIf="showCustomForm">
      <h1 class="fw-bold fs-2 text-center mb-4">Ingresar datos de tarjeta</h1>
      <form [formGroup]="customCardForm">
        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title fw-bold">Datos de la tarjeta</h5>

            <div class="mb-3">
              <label for="card_number" class="form-label">Número de tarjeta</label>
              <input
                autocomplete="off"
                placeholder="1234 5678 9012 3456"
                type="text"
                formControlName="card_number"
                [inputMask]="cardNumberMask"
                class="form-control"
                [ngClass]="{
                  'is-valid':
                    customCardForm.controls.card_number.valid &&
                    customCardForm.controls.card_number.value &&
                    (customCardForm.controls.card_number.dirty || customCardForm.controls.card_number.touched),
                  'is-invalid': customCardForm.controls.card_number | isControlInvalid | async
                }"
              />
              <app-input-error
                *ngIf="customCardForm.controls.card_number | isControlInvalid | async"
                [errors]="customCardForm.controls.card_number.errors!"
              />
            </div>

            <div class="mb-3">
              <label for="nombre" class="form-label">Nombre del titular</label>
              <input
                autocomplete="off"
                placeholder="Nombre como aparece en la tarjeta"
                type="text"
                formControlName="nombre"
                class="form-control"
                [ngClass]="{
                  'is-valid':
                    customCardForm.controls.nombre.valid &&
                    customCardForm.controls.nombre.value &&
                    (customCardForm.controls.nombre.dirty || customCardForm.controls.nombre.touched),
                  'is-invalid': customCardForm.controls.nombre | isControlInvalid | async
                }"
              />
              <app-input-error
                *ngIf="customCardForm.controls.nombre | isControlInvalid | async"
                [errors]="customCardForm.controls.nombre.errors!"
              />
            </div>

            <div class="row">
              <div class="mb-3 col-4">
                <label for="month" class="form-label">Mes</label>
                <input
                  autocomplete="off"
                  placeholder="MM"
                  type="text"
                  formControlName="month"
                  [inputMask]="expirationMonthMask"
                  class="form-control"
                  [ngClass]="{
                    'is-valid':
                      customCardForm.controls.month.valid &&
                      customCardForm.controls.month.value &&
                      (customCardForm.controls.month.dirty || customCardForm.controls.month.touched),
                    'is-invalid': customCardForm.controls.month | isControlInvalid | async
                  }"
                />
                <app-input-error
                  *ngIf="customCardForm.controls.month | isControlInvalid | async"
                  [errors]="customCardForm.controls.month.errors!"
                />
              </div>

              <div class="mb-3 col-4">
                <label for="year" class="form-label">Año</label>
                <input
                  autocomplete="off"
                  placeholder="AA"
                  type="text"
                  formControlName="year"
                  [inputMask]="expirationYearMask"
                  class="form-control"
                  [ngClass]="{
                    'is-valid':
                      customCardForm.controls.year.valid &&
                      customCardForm.controls.year.value &&
                      (customCardForm.controls.year.dirty || customCardForm.controls.year.touched),
                    'is-invalid': customCardForm.controls.year | isControlInvalid | async
                  }"
                />
                <app-input-error
                  *ngIf="customCardForm.controls.year | isControlInvalid | async"
                  [errors]="customCardForm.controls.year.errors!"
                />
              </div>

              <div class="mb-3 col-4">
                <label for="cvv" class="form-label">CVV</label>
                <input
                  autocomplete="off"
                  placeholder="123"
                  type="text"
                  formControlName="cvv"
                  [inputMask]="cvvMask"
                  class="form-control"
                  [ngClass]="{
                    'is-valid':
                      customCardForm.controls.cvv.valid &&
                      customCardForm.controls.cvv.value &&
                      (customCardForm.controls.cvv.dirty || customCardForm.controls.cvv.touched),
                    'is-invalid': customCardForm.controls.cvv | isControlInvalid | async
                  }"
                />
                <app-input-error
                  *ngIf="customCardForm.controls.cvv | isControlInvalid | async"
                  [errors]="customCardForm.controls.cvv.errors!"
                />
              </div>
            </div>
          </div>
        </div>

        <app-button class="mb-3" (clicked)="submitCustomCard()" [disabled]="isCustomFormInvalid()">
          Guardar tarjeta
        </app-button>
        <a href="#" class="add-card d-block text-center" (click)="$event.preventDefault(); closeCustomForm()">
          Cancelar
        </a>
      </form>
    </ng-container>
  </ng-container>
</div>
